export default __webpack_public_path__ + "static/media/chevron-left.e59ea485.svg";